(function () {
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"]/g, function (char) {
      return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[char];
    });
  }

  function cardMarkup(product) {
    var image = product.images && product.images[0] && product.images[0].src;
    var title = product.title || '';
    var handle = product.handle || '';
    return '<a class="dyu-mega-products__card" href="/products/' + encodeURIComponent(handle) + '">' +
      '<span class="dyu-mega-products__image">' +
        (image ? '<img src="' + image + '" alt="' + escapeHtml(title) + '" loading="lazy">' : '') +
      '</span>' +
      '<span class="dyu-mega-products__title">' + escapeHtml(title) + '</span>' +
    '</a>';
  }

  function reindex(mega) {
    mega.querySelectorAll('[data-dyu-tab]').forEach(function (tab, index) {
      tab.setAttribute('data-dyu-tab', index);
    });
    mega.querySelectorAll('[data-dyu-panel]').forEach(function (panel, index) {
      panel.setAttribute('data-dyu-panel', index);
    });
  }

  function normalizeTabLinks(mega) {
    var panels = mega.querySelectorAll('[data-dyu-panel]');
    mega.querySelectorAll('[data-dyu-tab]').forEach(function (tab, index) {
      if (tab.tagName.toLowerCase() === 'a') return;
      var viewAll = panels[index] && panels[index].querySelector('.dyu-mega-products__view-all');
      var link = document.createElement('a');
      link.href = viewAll ? viewAll.getAttribute('href') : '#';
      link.className = tab.className;
      link.setAttribute('data-dyu-tab', tab.getAttribute('data-dyu-tab') || index);
      link.innerHTML = tab.innerHTML;
      tab.replaceWith(link);
    });
  }

  function ensureAllEbike(mega) {
    var tabs = Array.from(mega.querySelectorAll('[data-dyu-tab]'));
    var titles = tabs.map(function (tab) { return tab.textContent.trim().toLowerCase(); });
    var isEbikeMenu = titles.some(function (title) { return title.indexOf('best sellers') > -1; }) &&
      titles.some(function (title) { return title.indexOf('folding') > -1; });
    var hasAllEbike = titles.some(function (title) { return title.indexOf('all e-bike') > -1 || title.indexOf('all ebike') > -1; });
    if (!isEbikeMenu || hasAllEbike) return;

    var nav = mega.querySelector('.dyu-mega-products__nav');
    var panelsWrap = mega.querySelector('.dyu-mega-products__panels');
    if (!nav || !panelsWrap) return;

    var newArrivalTab = tabs.find(function (tab) { return tab.textContent.trim().toLowerCase().indexOf('new arrival') > -1; });
    var newArrivalPanel = null;
    if (newArrivalTab) {
      newArrivalPanel = mega.querySelector('[data-dyu-panel="' + newArrivalTab.getAttribute('data-dyu-tab') + '"]');
    }

    var allTab = document.createElement('a');
    allTab.href = '/collections/electric-bikes';
    allTab.className = 'dyu-mega-products__tab';
    allTab.setAttribute('data-dyu-tab', '0');
    allTab.innerHTML = '<span>All E-Bike</span>';

    var panel = document.createElement('div');
    panel.className = 'dyu-mega-products__panel';
    panel.setAttribute('data-dyu-panel', '0');
    var firstGrid = mega.querySelector('.dyu-mega-products__panel .dyu-mega-products__grid');
    panel.innerHTML = '<div class="dyu-mega-products__grid">' + (firstGrid ? firstGrid.innerHTML : '') + '</div>' +
      '<a class="dyu-mega-products__view-all" href="/collections/electric-bikes">View All</a>';

    nav.insertBefore(allTab, newArrivalTab || null);
    panelsWrap.insertBefore(panel, newArrivalPanel || null);
    reindex(mega);

    fetch('/collections/electric-bikes/products.json?limit=3')
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (data) {
        if (!data || !data.products || !data.products.length) return;
        var grid = panel.querySelector('.dyu-mega-products__grid');
        grid.innerHTML = data.products.slice(0, 3).map(cardMarkup).join('');
      })
      .catch(function () {});
  }

  function initDyuMegaProducts() {
    document.querySelectorAll('[data-dyu-mega-products]').forEach(function (mega) {
      if (mega.dataset.ready === 'true') return;
      normalizeTabLinks(mega);
      ensureAllEbike(mega);
      reindex(mega);
      mega.dataset.ready = 'true';

      var tabs = mega.querySelectorAll('[data-dyu-tab]');
      var panels = mega.querySelectorAll('[data-dyu-panel]');

      function activate(index) {
        tabs.forEach(function (tab) {
          tab.classList.remove('is-active');
        });

        panels.forEach(function (panel) {
          panel.classList.remove('is-active');
        });

        if (tabs[index]) tabs[index].classList.add('is-active');
        if (panels[index]) panels[index].classList.add('is-active');
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('mouseenter', function () {
          activate(index);
        });

        tab.addEventListener('focus', function () {
          activate(index);
        });

        tab.addEventListener('click', function () {
          activate(index);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDyuMegaProducts);
  } else {
    initDyuMegaProducts();
  }

  document.addEventListener('shopify:section:load', initDyuMegaProducts);
})();
